package com.nonopn.skywatcher.design.widgets.abslists

enum class ListModelState {
    DEFAULT,
    LOADING,
    LOADED,
    ERROR
}
